var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import classNames from 'clsx';
import { ButtonToggleButton, ButtonToggleContainer } from './styles/button.styled';
export const ButtonToggle = (_a) => {
    var { options, initialActiveOption = 'left', dataTest = 'button-toggle' } = _a, props = __rest(_a, ["options", "initialActiveOption", "dataTest"]);
    const [activeOption, setActiveOption] = useState(initialActiveOption);
    useEffect(() => {
        setActiveOption(initialActiveOption);
    }, [initialActiveOption]);
    return (_jsx(ButtonToggleContainer, Object.assign({ "data-test": dataTest }, props, { children: options.map((option, index) => (_jsx(ButtonToggleButton, { type: "button", className: classNames({
                active: (!index && activeOption === 'left') || (index && activeOption === 'right'),
            }), "$isActive": (!index && activeOption === 'left') || (index && activeOption === 'right'), onClick: () => {
                setActiveOption(index ? 'right' : 'left');
            }, onKeyPress: ({ key }) => key === 'Enter' && setActiveOption(index ? 'right' : 'left'), children: option }, option))) })));
};
